import React, { useState } from 'react';
import { Popconfirm } from 'antd';
import { useAudioIndicator } from '@hooks/useAudioIndicator';
import useIsClinician from 'vl-common/src/hooks/useIsClinician';
import useUser from '@vl-core/hooks/useUser';

type CalloutProps = React.ComponentProps<typeof Popconfirm>;

const useSeenIndicatorBefore = () => {
  const { user_guid } = useUser();
  const key = `${user_guid}-seen-audio-indicator`;
  const [seenIndicatorBefore, setSeenIndicatorBefore] = useState(() => localStorage.getItem(key) === 'true');

  const markAsSeen = () => {
    localStorage.setItem(key, 'true');
    setSeenIndicatorBefore(true);
  };

  return { seenIndicatorBefore, markAsSeen };
};

const MicrophoneCallout = ({ children }: { children: React.ReactElement }) => {
  const { seenIndicatorBefore, markAsSeen } = useSeenIndicatorBefore();
  const { isListening } = useAudioIndicator();
  const isClinician = useIsClinician();

  const calloutProps: CalloutProps = {
    open: isListening && !seenIndicatorBefore && !isClinician,
    title: 'Sound activity',
    okText: 'Ok',
    showCancel: false,
    placement: 'topLeft',
    onConfirm: () => markAsSeen(),
    styles: { body: { width: '150px' } }
  };

  return (
    <Popconfirm {...calloutProps} zIndex={2}>
      <span style={{ display: 'inline-flex' }}>{children}</span>
    </Popconfirm>
  );
};

export default MicrophoneCallout;
